import { render, staticRenderFns } from "./Microsoft.vue?vue&type=template&id=37dad22b"
import script from "./Microsoft.vue?vue&type=script&setup=true&lang=js"
export * from "./Microsoft.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports